export class CookieKeys {
  static readonly channelRequestId = "channelRequestId";
  static readonly noCarOrDealerWarningClosed = "noCarOrDealerWarningClosed";
  static readonly consentPrefix = "consent_";
}
